import React from 'react'
import Link from 'gatsby-link'
import HomeLogo from '../Linking/homeLogo'


class Navbar extends React.Component {
    constructor(props){
        super(props);
        this.state = {isMenuOpen: false};
        this.handleToggle = this.handleToggle.bind(this); 
    }
    
    
    handleToggle(){
        this.setState(prevState => ({
            isMenuOpen: !prevState.isMenuOpen
          }));
    }

    render(){
       const isMenuActive =this.state.isMenuOpen?"is-active":"";

       return(
           <div className="nav-wrapper">
           <HomeLogo/>
            <button type="button" onClick={this.handleToggle} className={`hamburger hamburger--3dx ${isMenuActive}`} type="button">
                <span className="hamburger-box">
                <span className="hamburger-inner"></span>
                </span>
            </button>
             <nav className={`menu ${this.state.isMenuOpen?"menu-close":"menu-open"}`}>
            <ul>
            <li><Link to="/sobre-mi/" onClick={this.handleToggle}>Sobre mí</Link></li>
            <li><Link to="/portfolio/" onClick={this.handleToggle}>Portfolio</Link></li>
            <li><Link to="/blog/" onClick={this.handleToggle}>Blog</Link></li>
            </ul>
            </nav>
          </div>
      
       )
    }

}

export default Navbar;


// WEBPACK FOOTER //
// ./src/components/Navbar/navbar.js